import MicroModal from 'micromodal';
import naja from 'naja';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class Modal {
    static init(): void {
        MicroModal.init({
            openTrigger: 'data-micromodal-trigger', // Atribut pro spuštění modalu
            closeTrigger: 'data-micromodal-close', // Atribut pro zavření modalu
            disableScroll: false, // Vypneme vestavěné scrollování
            disableFocus: false, // Povolí/zakáže auto-focus na prvním prvku
            awaitOpenAnimation: false, // Čeká na dokončení animace při otevření
            awaitCloseAnimation: false, // Čeká na dokončení animace při zavření
            onShow: (modal) => {
                const modalContent = modal?.querySelector('.modal__container');
                if (modalContent) {
                    disableBodyScroll(modalContent);
                }
            },
            onClose: () => {
                // Clear all body scroll locks to ensure body is unlocked
                clearAllBodyScrollLocks();

                // Force remove any inline styles that might have been added
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
                document.body.style.top = '';

                // Remove any classes that might lock the body
                document.body.classList.remove('modal-open', 'is-locked');
            },
        });

        Modal.setupCustomOpenModal();
        Modal.setupSnippetListener();
    }

    private static setupCustomOpenModal(): void {
        const openButtons = document.querySelectorAll('[data-micromodal-trigger]');
        openButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const modalId = button.getAttribute('data-micromodal-trigger');
                if (modalId) {
                    MicroModal.show(modalId); // Ruční otevření modálního okna
                }
            });
        });

        // Add explicit handler for close buttons to ensure body scroll is restored
        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            if (target && target.closest('[data-micromodal-close]')) {
                // Force clear all body locks when any close button is clicked
                setTimeout(() => {
                    clearAllBodyScrollLocks();
                    document.body.style.overflow = '';
                    document.body.style.position = '';
                    document.body.style.width = '';
                    document.body.style.top = '';
                    document.body.classList.remove('modal-open', 'is-locked');
                }, 100);
            }
        });
    }

    private static setupSnippetListener(): void {
        naja.snippetHandler.addEventListener('afterUpdate', () => {
            // Reinitialize modal triggers after snippet updates
            Modal.setupCustomOpenModal();
        });
    }
}
